(function () {
    var superproto = GUI.Forms.Validation.Custom.prototype;
    /**
    * JavaScript Graphical User Interface
    * Forms.Validation.Checked implementation
    *
    * @author Sergey Ostapenko
    * @version 2.0
    * @namespace GUI.Forms.Validation
    * @extends GUI.Forms.Validation.Validator
    */
    GUI.Forms.Validation.Checked = Class.create();
    Object.extend(GUI.Forms.Validation.Checked.prototype, superproto);

    /**
     * Text of the error message, default is 'i18n.GUI_VALIDATION_SELECTED'
     * @type String
     */
    GUI.Forms.Validation.Checked.prototype.errorMessage = i18n(GUI.i18n.GUI_VALIDATION_SELECTED);

    /**
     * Type of the element, 'GUI.Forms.Validation.Checked'
     * @type String
     */
    GUI.Forms.Validation.Checked.prototype.elementType    = 'GUI.Forms.Validation.Checked';

    /**
     * Initialize validator
     * @param {Object} config configuration object
     */
    GUI.Forms.Validation.Checked.prototype.initialize = function (config) {
        // Call parent method
        superproto.initialize.call(this, config);
    };

    /**
     * Validates value
     * @param {String|Number} value Value to validate
     * @return {Boolean} true - valid, false - invalid
     */
    GUI.Forms.Validation.Checked.prototype.validateFunc = function (value) {
        var f = this.field;
        return f.checked;
    };
}());